import Marquee from "react-fast-marquee";

const words = ["Family-owned", "Footscray local", "Freshly roasted", "All welcome", "Good coffee", "Come as you are"];

export default function MarqueeBand() {
  return (
    <section data-testid="marquee-section" className="border-y border-[var(--line)] bg-cafe py-8">
      <Marquee speed={40} gradient={false} autoFill>
        {words.map((w, i) => (
          <span key={i} className="mx-12 inline-flex items-center gap-12">
            <span className="font-display text-4xl italic text-[var(--text)]/85 sm:text-6xl">{w}</span>
            <span className="text-accent text-3xl sm:text-5xl">✦</span>
          </span>
        ))}
      </Marquee>
    </section>
  );
}
